import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  accordionChild: {
    marginTop: '0.25em',
  },
  accordionChildren: {
    '&> div': {
      justifyContent: 'space-between',
      '&> span': {
        transform: 'rotate(270deg) !important',
      },
    },
  },
  iconContainer: {
    width: 48,
    height: 48,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      opacity: '0.7 !important',
    },
  },
  descriptionContainer: {
    display: 'flex',
    justifyContent: 'left',
    alignItems: 'center',
    cursor: 'auto',
    padding: '1.25em',
    wordBreak: 'break-all',
    backgroundColor: theme.palette.background.default,
    borderRadius: theme.shape.borderRadius,
    marginBottom: theme.spacing(2),
  },
  descriptionText: {
    padding: '1.25em',
    fontSize: 18,
    fontWeight: 400,
    letterSpacing: '0.025em !important',
    wordBreak: 'break-all',
  },
  cursorIcon: {
    '&:hover': {
      cursor: 'pointer !important',
    },
  },
  hoverContainerChildAccordion: {
    borderRadius: theme.shape.borderRadius,
    '&:hover': {
      borderColor: theme.palette.hover2,
    },
  },
  descriptionScriptText: {
    marginRight: '1em',
    marginLeft: '1em',
    color: theme.palette.text.main,
    fontWeight: '400',
    lineHeight: '1.55',
    letterSpacing: '0.07rem !important',
  },
  titleContainer:{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    padding: theme.spacing(1, 0),
  },
  descriptionFatherContainer: {
    backgroundColor: theme.palette.background.main,
    borderRadius: '1em',
    marginTop: '1em',
  },
  scriptDivider: {
    opacity: 0.5,
    border: 'none',
    height: '2px',
    margin: 0,
    marginRight: '0px',
    marginLeft: '0px',
    flexShrink: 0,
    backgroundColor: 'rgba(0,158,226,.1)',
  },
  shortcutContent: {
    width: '100%',
    display: 'flex',
    cursor: 'pointer',
    justifyContent: 'space-between',
    transition: 'all 0.3s ease',
    border: `2px solid transparent`,
    padding: 15,
    marginTop: 15,
    borderRadius: theme.shape.borderRadius,
    '& > * ': {
      flexGrow: 0,
      overflowWrap: 'anywhere',
      whiteSpace: 'pre-wrap',
    },
    '& h6 ': {
      fontSize: theme.typography.fontSize,
      marginBottom: 5,
      fontColor: theme.palette.text.primary,
    },
  },
  accordion: {
    borderRadius: theme.shape.borderRadius,
    transition: 'all 0.3s ease',
    border: `2px solid transparent`,
    margin: theme.spacing(2,0),
  },
}))

export default useStyles
